import axios from 'axios';
import { safeConsoleLog } from './devToolsDetection';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001'
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    // Log request for debugging - simplified to avoid circular references
    safeConsoleLog('API Request:', {
      url: config.url,
      method: config.method,
      baseURL: config.baseURL
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor with better error handling
instance.interceptors.response.use(
  (response) => {
    // Log successful response for debugging - simplified to avoid circular references
    safeConsoleLog('API Response:', {
      url: response.config.url,
      status: response.status,
      dataReceived: !!response.data
    });
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Only logout for actual auth failures, not login attempts
      const urlPath = error.config?.url || '';
      const noLogoutEndpoints = ['/auth/login', '/auth/supplier/login'];
      const isLoginEndpoint = noLogoutEndpoints.some(endpoint => urlPath.includes(endpoint));
      
      if (!isLoginEndpoint) {
        // Handle unauthorized access
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    // Add better error logging - simplified to avoid circular references
    safeConsoleLog('API Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.message,
      baseURL: error.config?.baseURL
    });
    return Promise.reject(error);
  }
);

export default instance; 